<style lang="scss" scoped>
.home-box {
  font-size: 16px;
  margin: 0 auto;
  padding-top: 220px;
  font-family: syht;
  background-image: linear-gradient(#fff, #fcfcfc);

  .title-box,
  .hz-box,
  .question-box {
    color: #000;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .title-box {
    padding-bottom: 190px;

    h1 {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 66px;
      font-weight: bold;
      padding-bottom: 44px;
    }

    h5 {
      font-family: syht;
      font-size: 40px;
      font-weight: bold;
      margin: 0;
    }
  }

  .question-box {
    padding-bottom: 146px;
    position: relative;
    &__search {
      position: absolute;
      right: 0;
      z-index: 999;
    }
    &__btn {
      margin-top: 166px;
      margin-bottom: 15px;
    }
    &__button {
      width: 330px;
      height: 46px;
      font-size: 18px;
      font-weight: bold;
      background: #fafafa;
      border-color: #ebebec;
      color: #000;
      &:hover {
        background: #fafafa;
        color: #000;
        border-color: #ebebec;
      }
    }
    &__title {
      font-family: Helvetica;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
  }

  .hz-box {
    padding-bottom: 120px;

    p {
      padding-bottom: 70px;
      color: #4286f5;
      font-size: 36px;
      line-height: 1;
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      a {
        border: 1px solid #ebebee;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        margin-bottom: 20px;
        img {
          width: 280px;
          height: 58px;
          // height: 100px;
          border-radius: 10px;
        }
      }
    }
  }

  .product-box {
    background: #f0f5f4;
    padding-bottom: 160px;

    &__title {
      padding-top: 120px;
      padding-bottom: 90px;
    }

    &__list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 1200px;
      margin: 0 auto;
    }

    &__item {
      height: 320px;
      width: 220px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      border-radius: 10px;

      img {
        width: 113px;
        height: 113px;
        margin-bottom: 40px;
      }
    }

    &__jieshao {
      font-weight: bold;
      font-size: 22px;
    }

    &__remark {
      color: #adb1ba;
    }
  }

  .api-box {
    background: #f0f5f4;
    margin-bottom: 160px;

    &__title {
      padding-bottom: 90px;
    }

    &__introduce {
      display: flex;
      width: 100%;
      justify-content: center;
    }

    &__left {
      width: 50%;
      height: 670px;
      display: flex;
      align-items: center;
      padding-left: 260px;
      padding-right: 60px;
      background: url("../../assets/newHome/APIDOCS.png") no-repeat;
      background-size: cover;
    }

    &__right {
      height: 670px;
      display: flex;
      align-items: center;
      padding-right: 260px;
      padding-left: 60px;
      background: #f5dd8e;
    }

    &__p1 {
      position: relative;
      font-weight: bold;
      font-size: 22px;
      padding-bottom: 10px;
      margin-bottom: 20px;

      &:after {
        content: "";
        position: absolute;
        width: 18px;
        height: 6px;
        bottom: -6px;
        background: #000;
        left: 0;
      }
    }

    &__p2 {
      font-size: 16px;
      padding-bottom: 66px;
      line-height: 1.5;
    }

    &__button {
      font-family: syht;
      background: transparent;
      border-color: #4286f5;
      font-size: 16px;
      color: #4286f5;
    }
  }

  .evaluation-box {
    &__remark {
      &:after {
        content: "";
        position: absolute;
        width: 18px;
        height: 6px;
        bottom: -6px;
        background: #000;
        left: 0;
      }
    }
    &__p3 {
      line-height: 2.5;
      padding-right: 120px;
    }
    &__title {
      padding-bottom: 90px;
    }

    &__title2 {
      padding-left: 80px;
      font-family: Arial;
      font-size: 20px !important;
      font-weight: bold;
      color: #000;
      line-height: 1;
      margin-bottom: 40px !important;
    }
    &__content {
      display: flex;
      position: relative;
      height: 700px;

      .evaluation-left {
        position: absolute;
        left: 0;
        top: 0;
        width: 60%;
        background: #d8e8fd;
        height: 700px;
      }
      .evaluation-right {
        background: #eef3f4;
        position: absolute;
        height: 628px;
        width: 50%;
        right: 0;
        top: 36px;
      }
      .evaluation-center {
        width: 1200px;
        margin: 0 auto;
        z-index: 999;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    &__left {
      width: 50%;
      p {
        position: relative;
        font-weight: bold;
        font-size: 22px;
        padding-bottom: 10px;
        margin-bottom: 20px;

        &:last-of-type {
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    &__right {
      width: 50%;
      p {
        font-size: 16px;
        color: #000;
        margin: 0;
        font-weight: bold;
      }
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      padding-left: 80px;
      justify-content: space-between;

      a {
        display: flex;
        align-items: center;
        height: 58px;
        margin-bottom: 20px;
        background: #fff;
        width: 240px;
        border-radius: 10px;
        justify-content: flex-start;
        align-items: center;
        text-decoration: none;
        img {
          width: 32px;
          height: 32px;
          margin-right: 20px;
          margin-left: 10px;
        }
      }
    }
    &__button {
      font-family: syht;
      background: transparent;
      border-color: #615839;
      font-size: 16px;
      color: #615839;
      &:hover {
        color: #615839;
        border-color: #615839;
      }
    }
  }
  .daily-box {
    background: #f0f5f4;
    padding-bottom: 150px;
    &__title {
      padding-bottom: 90px;
      padding-top: 160px;
    }
    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    &__item {
      width: 380px;
      height: 300px;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      padding: 18px;

      & > p:nth-of-type(1) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        padding-bottom: 15px;

        &:after {
          content: "";
          position: absolute;
          width: 40px;
          height: 2px;
          bottom: 0px;
          background: #4286f5;
          left: 0;
        }
      }
      .first {
        background: #deeaf3;
      }
      .sec {
        background: #fff;
      }
      .last {
        background: #fff;
      }
    }
    &__button1 {
      color: #4088f1;
      border-color: #4088f1;
      background: transparent;
      margin-bottom: 10px;
      &:hover {
        color: #4088f1;
        border-color: #4088f1;
      }
    }
    &__button2,
    &__button3 {
      color: #adb1ba;
      border-color: #adb1ba;
      background: transparent;
      margin-bottom: 10px;
      &:hover {
        color: #adb1ba;
        border-color: #adb1ba;
      }
    }
    &__title1 {
      font-family: syht;
      font-size: 22px;
      font-weight: bold;
      color: #4286f5;
      line-height: 1;
      margin-bottom: 20px;
    }
    &__title2 {
      font-family: Arial;
      font-size: 20px;
      font-weight: bold;
      color: #4286f5;
      line-height: 1;
      margin-bottom: 20px;
      position: relative;
    }
    &__title3 {
      margin-top: 10px;
      color: #adb1ba;
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      max-height: 84px;
      min-height: 84px;
      height: 84px;
    }
    &__title4 {
      color: #adb1ba;
      font-size: 12px;
      line-height: 1.5;
    }
    &__btn {
      display: flex;
      justify-content: center;
      margin-top: 90px;
    }
    &__button4 {
      color: #676041;
      border-color: #676041;
      background: transparent;
      margin-bottom: 10px;
      margin-right: 10px;
      &:hover {
        color: #676041;
        border-color: #676041;
      }
    }
  }
  .all-box {
    background: #deeaf3;
    padding-bottom: 120px;
    &__title {
      padding-top: 130px;
      padding-bottom: 100px;
    }
    &__list {
      display: flex;
      justify-content: space-between;
    }
    &__item {
      width: 33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 164px;
      border-right: 1px solid #4186f4;
      &:last-of-type {
        border-right: 0;
      }
    }
    &__title1 {
      font-family: Arial;
      font-size: 88px;
      color: #4186f4;
      font-weight: bold;
      line-height: 1;
    }
    &__title2 {
      font-family: syht;
      margin-top: 40px;
      font-size: 22px;
      color: #000;
      font-weight: bold;
      line-height: 1;
    }
  }

  .agi-box {
    background: #f0f5f4;
    padding-bottom: 140px;
    &__btn {
      padding-top: 85px;
      padding-bottom: 140px;
      display: flex;
      justify-content: center;
    }
    &__button1 {
      color: #676041;
      border-color: #676041;
      background: transparent;
      margin-bottom: 10px;
      margin-right: 10px;
      height: 50px;
      font-family: syht;
      font-weight: bold;
      font-size: 18px;
      line-height: 1;
      &:hover {
        color: #676041;
        border-color: #676041;
      }
    }
    &__title {
      padding-bottom: 80px;
    }
    &__list {
      display: flex;
      justify-content: space-between;
    }
    &__item {
      cursor: pointer;
      width: 31%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 350px;
      background: #fff;
      border-radius: 10px;
      img {
        width: 130px;
        height: 130px;
        margin-bottom: 55px;
      }
      &:last-of-type {
        border-right: 0;
      }
    }
    &__title2 {
      font-family: Arial;
      font-size: 20px;
      color: #000;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 10px;
    }
    &__title3 {
      font-family: syht;
      font-size: 14px;
      color: #9ca4aa;
      line-height: 1;
      margin-bottom: 10px;
    }
  }

  .sy-40 {
    font-family: syht;
    font-size: 40px;
    font-weight: bold;
    color: #000;
    margin-right: 60px;
    line-height: 1;
  }

  .ab-40 {
    font-family: Arial;
    font-size: 40px;
    font-weight: bold;
    color: #000;
    line-height: 1;
  }
  .w-1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .text-center {
    text-align: center;
  }
}
</style>
<template>
  <!--  通用人工智能-->
  <div class="home-box">
    <div class="title-box">
      <h1>Big Bang Transformer [乾元]大模型</h1>
      <!-- <h5>通用人工智能基础设施</h5> -->
      <h5 style="font-size:20px">实现通用人工智能AGI</h5>
      <h5 style="font-size:20px">建设以知识为中心的社会</h5>
      <h5 style="font-size:20px">加速粒子物理学发展，进而加速物质科学发展，进而对物质世界进行全面改造</h5>
    </div>
    <div class="question-box">
      <div class="question-box__content w-1200">
        <el-button icon="el-icon-search" class="question-box__search" @click="handleSubmit">提  问</el-button>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="通用" name="first"></el-tab-pane>
          <el-tab-pane label="代码" name="second"></el-tab-pane>
          <el-tab-pane label="金融" name="third"></el-tab-pane>
          <el-tab-pane label="图文" name="fourth"></el-tab-pane>
        </el-tabs>
        <el-input
          type="textarea"
          :rows="14"
          :placeholder="placeholder"
          v-model="textarea"
        >
        </el-input>
        <div class="question-box__btn">
          <el-button class="question-box__button" plain @click="handleSubmit"
            >试　　用</el-button
          >
        </div>
        <p class="question-box__title"><b>400-182-3520</b></p>
      </div>
    </div>
    <div class="hz-box">
      <p>合作伙伴</p>
      <div class="hz-box__list">
        <a href="#" v-for="(i, index) in hzList" :key="index">
          <img :src="i.img" />
        </a>
      </div>
    </div>
    <div class="product-box">
      <div class="product-box__title text-center">
        <span class="sy-40">产品</span>
        <span class="ab-40">Product</span>
      </div>
      <div class="product-box__list">
        <div class="product-box__item" v-for="(i, index) in productList" :key="index">
          <img :src="i.img" alt="" />
          <p class="product-box__jieshao">{{ i.title }}</p>
          <p class="product-box__remark">{{ i.remark }}</p>
        </div>
      </div>
    </div>
    <div class="api-box">
      <div class="api-box__title text-center">
        <span class="ab-40">API DOCS</span>
      </div>
      <div class="api-box__introduce">
        <div class="api-box__left">
          <!-- <img :src="ApiDocs" alt="" /> -->
        </div>
        <div class="api-box__right">
          <div>
            <p class="api-box__p1">BBT API</p>
            <p class="api-box__p2">
              我们的API文档提供了模型的Index，包括BBT1到BBT3每一个版本模型迭代的细节，以及从基础模型到金融模型，代码模型和文生图模型的调用方法。
            </p>
            <div>
              <el-button plain class="api-box__button">了解更多　　→</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluation-box">
      <div class="evaluation-box__title text-center">
        <span class="sy-40">评测数据</span>
        <span class="ab-40">Evaluation Dataset</span>
      </div>
      <div class="evaluation-box__content">
        <div class="evaluation-left"></div>
        <div class="evaluation-right"></div>
        <div class="evaluation-center">
          <div class="evaluation-box__left">
            <p>BBT CFLEB</p>
            <!-- <p class="evaluation-box__remark">Description from the authors</p> -->
            <p class="evaluation-box__p3">
              超对称团队针对金融行业的预训练模型发布了一套目前中文领域金融大模型最专业的评测数据集BBT CFLEB，包含八个标准语言任务，用以衡量不同的模型的多维能力，并促进金融大模型研发。现开源于Github，同时可在BBT模型网站上查看研发细节，评测数据，不同模型排名甚至可以下载开源模型根据自己需求训练下游任务并上传展示，欢迎不同团队打榜。
            </p>
          </div>
          <div class="evaluation-box__right">
            <p class="evaluation-box__title2">Tasks</p>
            <div class="evaluation-box__list">
              <a href="#" v-for="(i, index) in evaluationList" :key="index">
                <img :src="i.img" />
                <p>{{ i.title }}</p>
              </a>
            </div>
            <div style="padding-left: 80px; margin-top: 60px">
              <el-button plain class="evaluation-box__button"><a href="https://bbt.ssymmetry.com/evaluation.html">了解更多　　→</a></el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="daily-box">
      <div class="daily-box__title text-center">
        <span class="sy-40">每日摘要</span>
        <span class="ab-40">Daily News</span>
      </div>
            <div class="daily-box__content w-1200">
        <div class="daily-box__list">
          <div class="daily-box__item first">
            <p>
              <span class="daily-box__title1">郑州银行：成功发行50亿元金融债券</span>
              <!-- <span class="daily-box__title2">Montai convertible bonds</span> -->
            </p>
            <p class="daily-box__title3">
              3月14日电，郑州银行公告,公司近日在全国银行间债券市场成功发行郑州银行股份有限公司2023年第一期金融债券。本期债券于2023年3月9日簿记建档，并于2023年3月13日发行完毕，发行规模为人民币50亿元，品种为3年期固定利率债券，票面利率为3.02%。
            </p>
            <div>
              <!-- <el-button class="daily-box__button1"><a href="http://125.74.158.86:2333/abstract">查看详情→</a></el-button> -->
            </div>
            <p class="daily-box__title4">2023-03-14 11:47:50</p>
          </div>
          <div class="daily-box__item sec">
            <p>
              <span class="daily-box__title1">国机精工：拟使用1.17亿元闲置募集资金暂时补充流动资金</span>
              <!-- <span class="daily-box__title2">Montai convertible bonds</span> -->
            </p>
            <p class="daily-box__title3">
              3月14日电，国机精工公告,公司拟使用暂时闲置募集资金1.17亿元暂时补充流动资金，使用期限自董事会审议通过之日起不超过12个月。
            </p>
            <div>
              <!-- <el-button class="daily-box__button2"><a href="http://125.74.158.86:2333/abstract">查看详情→</a></el-button> -->
            </div>
            <p class="daily-box__title4">2023-03-14 11:45:55</p>
          </div>
          <div class="daily-box__item last">
            <p>
              <span class="daily-box__title1">成都路桥：控股股东拟将所持15.55%股份表决权不可撤销地委托给东君泰达行使</span>
              <span class="daily-box__title2">Montai convertible bonds</span>
            </p>
            <p class="daily-box__title3">
              3月14日电，成都路桥公告,控股股东宏义嘉华与公司持股5%股东东君泰达签署了表决权委托协议，宏义嘉华将其持有的1.18亿股公司股份（占公司总股本的15.55%）对应的全部表决权、召集权、提名和提案权、参会权、监督建议权、投票权等权利不可撤销地全权委托给东君泰达行使。
            </p>
            <div>
              <!-- <el-button class="daily-box__button3"><a href="http://125.74.158.86:2333/abstract">查看详情→</a></el-button> -->
            </div>
            <p class="daily-box__title4">2023-03-14 11:45:55</p>
          </div>
        </div>
        <div class="daily-box__btn">
          <el-button class="daily-box__button4"><a href="http://125.74.158.86:2333/abstract">查看详情→</a></el-button>
        </div>
      </div>
    </div>
    <div class="all-box">
      <div class="all-box__title text-center">
        <span class="sy-40">全A指数</span>
        <span class="ab-40">A Market Index</span>
      </div>
      <div class="all-box__content w-1200">
        <div class="all-box__list">
          <div class="all-box__item">
            <p class="all-box__title1">10</p>
            <p class="all-box__title2">情绪</p>
          </div>
          <div class="all-box__item">
            <p class="all-box__title1">+3.7</p>
            <p class="all-box__title2">较上期</p>
          </div>
          <div class="all-box__item">
            <p class="all-box__title1">+25%</p>
            <p class="all-box__title2">变动</p>
          </div>
        </div>
      </div>
    </div>
    <div class="agi-box">
      <div class="agi-box__btn">
        <el-button class="agi-box__button1">了解更多　→</el-button>
      </div>
      <div class="agi-box__title text-center">
        <span class="sy-40">AGI研究</span>
        <span class="ab-40">AGI Research</span>
      </div>
      <div class="agi-box__content w-1200">
        <div class="agi-box__list">
          <div class="agi-box__item" v-for="(i, index) in agiList" :key="index">
            <img :src="i.img" alt="" />
            <p class="agi-box__title2">{{ i.title }}</p>
            <p class="agi-box__title3">{{ i.remark }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiDocs from "../../assets/newHome/APIDOCS.png";
import emotion from "../../assets/newHome/emotion.png";
import photo from "../../assets/newHome/photo.png";
import question from "../../assets/newHome/question.png";
import summary from "../../assets/newHome/summary.png";
import translate from "../../assets/newHome/translate.png";

import FinCQA from "../../assets/newHome/FinCQA.png";
import FinFE from "../../assets/newHome/FinFE.png";
import FinNA from "../../assets/newHome/FinNA.png";
import FinQA from "../../assets/newHome/FinQA.png";

import Duicheng from "../../assets/newHome/duichen.png";
import Jiyin from "../../assets/newHome/jiyin.png";
import Yuanzi from "../../assets/newHome/yuanzi.png";

import Hz1 from "../../assets/newHome/1.png";
import Hz2 from "../../assets/newHome/2.png";
import Hz3 from "../../assets/newHome/3.png";
import Hz4 from "../../assets/newHome/4.png";
import Hz5 from "../../assets/newHome/5.png";
import Hz6 from "../../assets/newHome/6.png";
import Hz7 from "../../assets/newHome/7.png";
import Hz8 from "../../assets/newHome/8.png";

export default {
  name: "homeNew",
  data() {
    return {
      activeName: "first",
      textarea: "",
      placeholder: "通用对话暂不开放，仅开放代码对话接口，请选择代码",
      ApiDocs: ApiDocs,
      hzList: [
        {
          img: Hz1
        },
        {
          img: Hz2
        },
        {
          img: Hz3
        },
        {
          img: Hz4
        },
        {
          img: Hz5
        },
        {
          img: Hz6
        },
        {
          img: Hz7
        },
        {
          img: Hz8
        }
      ],
      productList: [
        {
          title: "对话",
          remark: "Question",
          img: question
        },
        {
          title: "摘要",
          remark: "Summary",
          img: summary
        },
        {
          title: "翻译",
          remark: "Translate",
          img: translate
        },
        {
          title: "情绪",
          remark: "Emotion",
          img: emotion
        },

        {
          title: "文生图",
          remark: "Photo",
          img: photo
        }
      ],
      evaluationList: [
        {
          title: "FinFE",
          img: FinFE
        },
        {
          title: "FinCQA",
          img: FinCQA
        },
        {
          title: "FinQA",
          img: FinQA
        },
        {
          title: "FinNA",
          img: FinNA
        }
      ],
      agiList: [
        {
          img: Yuanzi,
          title: "BBT 科学大模型",
          remark: "BBT Science"
        },
        {
          img: Jiyin,
          title: "BBT FOLD",
          remark: "BBT FOLD"
        },
        {
          img: Duicheng,
          title: "BBT 涌现",
          remark: "BBT Emergence"
        }
      ]
    };
  },
  components: {},
  methods: {
    handleClick(tab, event) {
      console.log(this.activeName);
      switch (this.activeName) {
        case "first":
          this.placeholder = "通用对话暂不开放，仅开放代码对话接口，请选择代码";
          break;
        case "second":
          this.placeholder = "代码";
          break;
        case "third":
          this.placeholder = "金融暂不开放，仅开放代码对话接口，请选择代码";
          break;
        case "fourth":
          this.placeholder = "图文对话暂不开放，仅开放代码对话接口，请选择代码";
          break;

        default:
          break;
      }
    },
    handleSubmit() {
      // 根据cookie中是否有token判断是否登录
      if (!this.$cookie.get("token")) {
        this.$message({
          message: "请先登录",
          type: "warning"
        });
        this.$router.push({
          path: "/login",
          query: {
            type: this.activeName,
            keyword: this.textarea,
          }
        });
      } else {
        this.$router.push({
          path: "/gptTalk",
          query: {
            keyword: this.textarea,
            type: this.activeName
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/homeNew/index.vue